import { AgentTemplateKind } from '@reach/shared-types/agents';
import { MessageSquareText, Phone, type LucideIcon, type LucideProps } from 'lucide-react';

const TEMPLATE_KIND_ICONS = {
  [AgentTemplateKind.SMS]: MessageSquareText,
  [AgentTemplateKind.VOICE]: Phone,
} as const satisfies Record<AgentTemplateKind, LucideIcon>;

interface TemplateKindIconProps extends LucideProps {
  kind: AgentTemplateKind;
}

export const TemplateKindIcon = ({ kind, ...iconProps }: TemplateKindIconProps) => {
  const Icon = TEMPLATE_KIND_ICONS[kind];
  return <Icon aria-hidden="true" {...iconProps} />;
};
